

//export const CORE_URL = "http://localhost:4000";
export const CORE_URL = "https://webapi.php-area.de";
//export const CORE_URL = "http://localhost:4000";
